// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bMeX","content":"styles_content__2_t6A","image":"styles_image__21aP8"};